module.exports = __webpack_public_path__ + "media/images/venue-noregister-ee2bfb0445f98239a66f8132fc3004bf.png";